import { refreshTokenHeader } from '../config'

type Headers = Record<string, string>

export const getAccessTokenFromHeaders = (
  headers: Headers
): string | undefined => headers.authorization

export const getRefreshTokenFromHeaders = (
  headers: Headers
): string | undefined => headers[refreshTokenHeader]
